import React, { useMemo } from 'react';
import { Col, Row } from 'react-bootstrap';
import StatsCard from './statsCard/StatsCard';
import { Props } from './stats.type';
import { StatsSet } from '../recruiterDashboard.type';

const getStatsCount = (data: StatsSet) => {
  const countObj: {
    [key: string]: number;
  } = {};
  for (const key in data) {
    if (Object.prototype.hasOwnProperty.call(data, key)) {
      const value = data[key];
      countObj[key] = Object.values(value)
        .map(item => Object.values(item))
        .flat(1)
        .reduce((acc, item) => acc + item, 0);
    }
  }
  return countObj;
};

function Stats({ data }: Props) {
  const statsValues = useMemo(() => {
    return data && data.stats ? getStatsCount(data.stats) : {};
  }, [data]);
  return (
    <Row className="mb-3 g-3">
      <Col xs={12} md={6} xl={4}>
        <StatsCard
          label="Applications"
          value={statsValues.applications || 0}
          rate={data?.report?.applications || 0}
          type="application"
        />
      </Col>
      <Col xs={12} md={6} xl={4}>
        <StatsCard
          label="Shorlisted"
          value={statsValues.shortlist || 0}
          rate={data?.report?.shortlist || 0}
          type="shortlisted"
        />
      </Col>
      <Col xs={12} md={6} xl={4}>
        <StatsCard
          label="Rejected"
          value={statsValues.rejected || 0}
          rate={data?.report?.rejected || 0}
          type="rejected"
        />
      </Col>
    </Row>
  );
}

export default Stats;
